<header>
  <a routerLink="/">Home</a>
  <a routerLink="/test">Test</a>
</header>
<main id="content">
  <div id="header">
    <h1>Ryes Above's Baubles</h1>
    <button id="rockButton" (click)="triggerRocks($event)">Enable Rocks</button>
    <button id="status" (click)="getStatus($event)">Get Status</button>
  </div>

  <router-outlet></router-outlet>

  <div id="toast-container"></div>
</main>